import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    multi_image: [
      'shop now - image1',
      'shop now - image2',
      'shop now - image3',
      'shop now - image4',
      'shop now - image5'
    ],
    multi_button: [
      'shop now - button1',
      'shop now - button2',
      'shop now - button3',
      'shop now - button4',
      'shop now - button5'
    ],
    left_button: [
      'never show - button1',
      'never show - button2',
      'never show - button3',
      'never show - button4',
      'never show - button5'
    ],
    right_button: [
      'close - button1',
      'close - button2',
      'close - button3',
      'close - button4',
      'close - button5'
    ]
  }
};

const AutoModalSlideTracking: FC<any> = () => {
  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  const style = `
.root_tracking {
    width: 100%;
    height: 100%;

    overflow: hidden;
    position: relative;
    background: none;

    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, 0.8);
    }
    .center {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      display: flex;
      flex-direction: column;
      gap: 2rem;
    }
    .modal_wrapper {
      width: 100%;
      padding: 2rem 0 1rem 0;
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list {
      width: 100%;
      height: 12rem;
    }
    .slick_image_wrapper {
      min-width: 12rem;
      max-width: 12rem;
      min-height: 12rem;
      max-height: 12rem;
      outline: 0;
      overflow: hidden;
    }
    .slick_image_wrapper img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .contents_box {
      width: 100%;
      padding: 0 1rem;
    }
    .contents_box .title {
      width: 100%;
      height: 3rem;

      display: flex;
      align-items: center;
    }

    .dot_wrapper {
      margin-top: 1rem;
    }
    .dot_wrapper,
    .dot_wrapper li {
      height: 0.25rem;
    }
    .contents_box .sub_title {
      width: 100%;
      height: 4rem;
    }

    .bar_wrapper {
      height: 0.25rem;
    }

    .btn_wrapper {
      width: 100%;
      height: 3rem;
      padding: 0;
    }

    .bottom_input {
      width: 1.25rem;
      height: 1.25rem;
    }
    .bottom_wrapper {
      height: 1.25rem;
    }
    .bottom_wrapper .style01 {
      width: 100%;
      height: 2.5rem;
    }
    .bottom_wrapper .style02 {
      width: 100%;
      height: 2.5rem;
    }

    .tracking_center {
      display: flex;
      align-items: center;
      justify-content: end;
    }
}
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_tracking">
        <div className="center">
          <div className="modal_wrapper">
            <div className="contents_box">
              <div className="title" />
              <div className="sub_title" />
            </div>
            <div className="slick_wrapper tracking_center">
              <EditTracking
                value={tracking?.multi_image?.[currentIndex]}
                type="multi_image"
              />
            </div>
            <div className="bar_wrapper" />
            <div className="btn_wrapper tracking_center">
              <EditTracking
                value={tracking?.multi_button?.[currentIndex]}
                type="multi_button"
              />
            </div>
          </div>
          <div className="bottom_wrapper">
            <span className="style01 tracking_center">
              <EditTracking
                value={tracking?.left_button?.[currentIndex]}
                type="left_button"
              />
            </span>
            <span className="style02 tracking_center">
              <EditTracking
                value={tracking?.right_button?.[currentIndex]}
                type="right_button"
              />
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
export default AutoModalSlideTracking;
